import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { forwardRef } from 'react';
import { getAvailableChallenges, updateChallenge, bulkEnrollChallenge, testEnrollChallenge } from '../../actions/adminActions';
import { translateChallengeType, translateGameType, translateHcpType } from '../../utils/translate'
import MaterialTable from "material-table";
import Grid from '@material-ui/core/Grid'
import AddBox from '@material-ui/icons/AddBox';
import GroupAdd from '@material-ui/icons/GroupAdd';
import PersonAdd from '@material-ui/icons/PersonAdd';
import ArrowDownward from '@material-ui/icons/ArrowDownward';
import Check from '@material-ui/icons/Check';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import ChevronRight from '@material-ui/icons/ChevronRight';
import Clear from '@material-ui/icons/Clear';
import DeleteOutline from '@material-ui/icons/DeleteOutline';
import Edit from '@material-ui/icons/Edit';
import FilterList from '@material-ui/icons/FilterList';
import FirstPage from '@material-ui/icons/FirstPage';
import LastPage from '@material-ui/icons/LastPage';
import Remove from '@material-ui/icons/Remove';
import SaveAlt from '@material-ui/icons/SaveAlt';
import Search from '@material-ui/icons/Search';
import ViewColumn from '@material-ui/icons/ViewColumn';
import { Checkbox, Switch, TextField } from '@material-ui/core';
import Alert from '@material-ui/lab/Alert';


const tableIcons = {
    Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
    Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
    Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
    DetailPanel: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
    Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
    Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
    FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
    LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
    NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    PreviousPage: forwardRef((props, ref) => <ChevronLeft {...props} ref={ref} />),
    ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
    SortArrow: forwardRef((props, ref) => <ArrowDownward {...props} ref={ref} />),
    ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
    ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />)
};

export const AvailableChallenges = () => {

    var columns = [{ title: "id", field: "id", hidden: true },
        { title: "Name", field: "name" },
        { title: "Type", render: rowData => translateChallengeType(rowData.type) },
        { title: "Game Type", render: rowData => translateGameType(rowData.gameType) },
        { title: "Hcp Type", render: rowData => translateHcpType(rowData.hcpType) },
        { title: "Fee", field: "fee", type: 'currency' },
        { title: "MaxParticipants", field: "maxParticipans", type: 'numeric' },
        {
            title: "Disabled", field: "disabled", type: 'boolean',
            //render: rowData => <Switch value={rowData.disabled} checked={rowData.disabled} />, render works
           // editComponent: props => <Switch value={props.disabled} checked={props.disabled} onChange={e => props.onChange(e.target.value)} /> //editComponent does not work
        },
        { title: "NumberOfParticipants", field: "numberOfParticipants", editable: 'never', type: 'numeric'}
                  ];
    const dispatch = useDispatch();

    const { challenges, remoteHasError, remoteErrorMessages } = useSelector(state => ({
        challenges: state.adminReducer.availableChallenges,
        remoteHasError: state.adminReducer.isError,
        remoteErrorMessages: state.adminReducer.errorMessages
    }), shallowEqual);

    const [isError, setIsError] = useState(remoteHasError)
    const [errorMessages, setErrorMessages] = useState(remoteErrorMessages)

    useEffect(() => {
        dispatch(getAvailableChallenges());
    }, ['All']); //Avoids infinite loop

    useEffect(() => {
        setIsError(remoteHasError);
    }, [remoteHasError]);

    useEffect(() => {
        setErrorMessages(remoteErrorMessages);
    }, [remoteErrorMessages]);

    const handleRowUpdate = (newData, oldData, resolve) => {
        console.log("newData=" + newData.disabled);
        console.log("oldData=" + oldData.disabled);
        let errorList = [];
        if (isNaN(newData.fee)) {
            errorList.push(newData.fee +" is not a valid number")
        }

        if (errorList.length < 1) {
            dispatch(updateChallenge(newData.id, newData.fee, newData.maxParticipans, newData.disabled));
        }
        else {
            setErrorMessages(errorList)
            setIsError(true)
        }
        resolve();
    }

    return (
        <Grid container spacing={1}>

            <Grid item xs={9}>
            <div>
                {isError &&
                    <Alert severity="error">
                        {errorMessages.map((msg, i) => {
                            return <div key={i}>{msg}</div>
                        })}
                    </Alert>
                }
            </div>
            <MaterialTable
                    title="Challenges"
                    columns={columns}
                    data={challenges}
                    icons={tableIcons}
                    options={{
                        pageSize: 15,
                        pageSizeOptions: [15,50],
                        toolbar: true,
                        paging: false,
                        search: false,
                        actionsColumnIndex: -1,
                    }}
                    actions={[
                        rowData => ({
                            icon: () => <PersonAdd />,
                            tooltip: 'Test-enroll one player by email',
                            hidden: (rowData.type !== 'FREE' && rowData.type !== 'SPONSORED') || rowData.disabled,
                            onClick: (event, row) => {
                                const label = row.name ? `"${row.name}" (${translateHcpType(row.hcpType)})` : `challenge ${row.id}`;
                                const email = window.prompt(`Enter the email of the player to test-enroll into ${label}:`);
                                if (email && email.trim()) {
                                    dispatch(testEnrollChallenge(row.id, email.trim()));
                                }
                            }
                        }),
                        rowData => ({
                            icon: () => <GroupAdd />,
                            tooltip: 'Bulk-enroll all matching players (HCP-bucketed, idempotent)',
                            hidden: (rowData.type !== 'FREE' && rowData.type !== 'SPONSORED') || rowData.disabled,
                            onClick: (event, row) => {
                                const label = row.name ? `"${row.name}" (${translateHcpType(row.hcpType)})` : `challenge ${row.id}`;
                                if (window.confirm(`Bulk-enroll every eligible player into ${label}?\n\nAlready-enrolled players are skipped.`)) {
                                    dispatch(bulkEnrollChallenge(row.id));
                                }
                            }
                        })
                    ]}
                    editable={{
                        onRowUpdate: (newData, oldData) =>
                            new Promise((resolve) => {
                                handleRowUpdate(newData, oldData, resolve);
                            }),

                    }}
            />
            </Grid>
            <Grid item xs={3}></Grid>
        </Grid>
        );
}